export default "__VITE_ASSET__BA96AJ5J__"